export default __webpack_public_path__ + "a38264472f2e9cf7c9b1bcaaf6aa8517.svg";